module.exports = __webpack_public_path__ + "images/emoji/ear.2eae51c6cfd69bb56b54.png";